import { api } from '../../api/client';

/** One booking the signed-in coach still owes for, as /api/bookings/mine/outstanding reports it. */
export interface OutstandingPayment {
  bookingId: number;
  venueName: string;
  pitchName: string;
  teamName: string;
  startUtc: string;
  endUtc: string;
  pricePence: number;
  /** null = an admin payment link with no deadline; otherwise a real countdown. */
  holdExpiresUtc: string | null;
}

/** Shared by the after-login nudge and the My payments page — one cache entry, one request. */
export const OUTSTANDING_KEY = ['bookings', 'mine', 'outstanding'];

export const fetchOutstanding = () => api<OutstandingPayment[]>('/api/bookings/mine/outstanding');

/** Minutes left on a live hold, or null when there is no deadline. */
export function minutesLeft(holdExpiresUtc: string | null): number | null {
  if (!holdExpiresUtc) return null;
  return Math.max(0, Math.round((Date.parse(holdExpiresUtc) - Date.now()) / 60000));
}

export function fmtSlot(startUtc: string, endUtc: string): string {
  const start = new Date(startUtc);
  const end = new Date(endUtc);
  const day = start.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  const from = start.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  const to = end.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  return `${day}, ${from}–${to}`;
}
